import { render, staticRenderFns } from "./answerExamPage.vue?vue&type=template&id=6d9588d1&scoped=true"
import script from "./answerExamPage.vue?vue&type=script&lang=js"
export * from "./answerExamPage.vue?vue&type=script&lang=js"
import style0 from "./answerExamPage.vue?vue&type=style&index=0&id=6d9588d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9588d1",
  null
  
)

export default component.exports